module.exports = __webpack_public_path__ + "img/PL08945.94757168.png";